import { onReady } from "../../utils/events/onReady";
import { addEvent } from "../../utils/events/events";
import aos from "aos";

export class Blog {
    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     */
    dom = {
        container: undefined
    };

    state = {
        open: false
    };

    /**
     *
     * @param {Element} domReference - The element to work from
     *
     * Blog layout currently used for both News and Blog/Our Community pages.
     */
    constructor(domReference) {
        this.dom.container = domReference;
        onReady(() => this.init(this.dom.container));
    }

    handleButtonStatus(lastPage, thisPage, year) {
        if (lastPage !== thisPage) {
            this.dom.container.querySelector(
                "#blog__load-more-" + year
            ).classList.remove("hidden");
        } else {
            this.dom.container.querySelector(
                "#blog__load-more-" + year
            ).classList.add("hidden");
        }
    }

    async fetchResult(page, pageIndex, year) {
        const endpoint = `/Umbraco/Api/${page}Overview/Get${page}Paginated?page=${pageIndex}&year=${year}`;
        const response = await fetch(endpoint);
        const results = await response.json();
        this.createItems(results, year);
    }

    createItems(results, year) {
        this.handleButtonStatus(results.totalCount, results.pageNumber, year);

        const gridContainer = this.dom.container.querySelector(
            ".blog__grid-" + year
        );

        const pagePosts = document.createElement("div");
        const eachPost = results.content.forEach((post, index) => {
            pagePosts.innerHTML += `
                <div class="blog__grid--item" data-aos="fade-up" data-aos-offset="50" data-aos-duration="1150">
                    <a href="${post.link}" >
                        <img loading="lazy" class="blog__grid--item__img ${index % 2 === 0 ? "even" : "odd"
                }"
                        src="${post.imageUrl}" alt="${post.altText
                    ? post.altText
                    : "Billede til artikel: " + post.headline
                }" />
                        <div class="blog__grid--item__info">
                            <div class="blog__grid--item__info-date">${post.createDate
                }</div>
                            <div class="blog__grid--item__info-seperator">${post.tag ? "|" : ""
                }</div>
                            <div class="blog__grid--item__info-tag">${post.tag
                }</div>
                        </div>
                        <div class="blog__grid--item__headline">${post.headline
                }</div>
                        <div class="blog__grid--item__text">
                        ${post.subHeading}
                        </div>
                    </a>

                    <a class="itemLink" href="${post.link}" role="link">${post.linkText ? post.linkText : "Læs mere"
                }</a>
                </div>
            `;
        });
        gridContainer.append(pagePosts);
    }

    init() {
        aos.init({
            once: true
        });

        const page = this.dom.container.dataset.page;
        const allButtons = this.dom.container.querySelectorAll(
            'span[id^="blog__load-more-"]'
        );

        allButtons.forEach(yearButton => {
            let currentPage = 1;
            let nextPage = 1;
            const year = yearButton.id.slice(16);
            this.fetchResult(page, currentPage, year);
            yearButton.addEventListener("click", () => {
                nextPage = nextPage + 1;
                currentPage = nextPage;
                this.fetchResult(page, nextPage, year);
            });
        });
    }
}
